import { appFormUtil } from 'modules/common';
import * as ds from './dataService';
import React from 'react';
import { StyledDropDown } from 'modules/components/layer01';



export type SelectWorkTradeFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object> (props: SelectWorkTradeFieldProps<T>) => {
  const { data } = ds.useQuery();
  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
    />
  );
};
